export const productVideo = ()=>{
    document.addEventListener('DOMContentLoaded', () => {
        const playButtons = document.querySelectorAll('.js-play-video');

        playButtons.forEach(button => {
            button.addEventListener('click', function() {
                const videoSrc = this.getAttribute('data-video-src');
                const wrapper = this.parentElement;
                if (!videoSrc) return;

                wrapper.style.transition = 'opacity 0.4s ease';
                wrapper.style.opacity = '0';

                setTimeout(() => {
                    const video = document.createElement('video');
                    video.src = videoSrc;
                    video.controls = true;
                    video.autoplay = true;
                    video.playsInline = true;
                    video.classList.add('w-full', 'h-full', 'object-cover');

                    wrapper.innerHTML = '';
                    wrapper.appendChild(video);

                    wrapper.style.opacity = '1';
                    video.play();
                }, 400);
            });
        });
    });
}